import React from "react";
import styled from "styled-components";
import { Stack } from "react-bootstrap";
import { useMemo } from "react";
import { DevolucionVenta } from "../../services/ventasServicios";
import { dateCompareStr } from "../../utils/dateUtils";
import TableTitle from "../organisms/TableTitle";
import DevolucionesTable from "./DevolucionesTable";

function DevolucionesTableSection({ devoluciones }: { devoluciones: DevolucionVenta[] }) {
  const items = useMemo(() => {
    let devolucionesOrdenadas = devoluciones;
    devolucionesOrdenadas.sort((itemA, itemB) => {
      return dateCompareStr(itemA.fecha, itemB.fecha);
    });
    return devolucionesOrdenadas;
  }, [devoluciones]);

  if (devoluciones.length === 0) {
    return <></>;
  }

  return (
    <ResponsiveTableSection>
      <TableTitle>{"Devoluciones"}</TableTitle>
      <TableWrapper>
        <Stack gap={4}>
          <DevolucionesTable items={items} />
        </Stack>
      </TableWrapper>
    </ResponsiveTableSection>
  );
}

const ResponsiveTableSection = styled("div")`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableWrapper = styled("div")`
  position: relative;
  clear: both;
  zoom: 1;
`;

export default DevolucionesTableSection;
